import { IApiResponse } from 'types'
import { FAQ_LIST } from './CONSTANTS'
import { request } from 'services/base'
import { IFaqResponse } from 'types/faq/types'

export const getFAQList = async (): Promise<IApiResponse<IFaqResponse[]>> =>
  await request({ url: FAQ_LIST, method: 'get' })
